import { connect } from "react-redux";
import { Dispatch } from "react";
import actions from "../redux/actions/Index";
import { IGetQueryParams } from "../interfaces/Index";
import ProductCityLevelPage from "../components/pages/productCityLevel/ProductCityLevelPage";

export const mapStateToProps = (state: any) => {
  return {
    isLoading: state.productCityLevel.isLoading,
    isError: state.productCityLevel.isError,
    error: state.productCityLevel.error,
    isProductCityLevelAdded: state.productCityLevel.isProductCityLevelAdded,
    isFetchProductCityLevelLoading:
      state.productCityLevel.isFetchProductCityLevelLoading,
    isFetchProductCityLevelError:
      state.productCityLevel.isFetchProductCityLevelError,
    productsCityLevel: state.productCityLevel.productsCityLevel,
    pagination: state.productCityLevel.pagination,
    isProductCityLevelUpdated: state.productCityLevel.isProductCityLevelUpdated,
    isProductCityLevelBulkUploading:
      state.productCityLevel.isProductCityLevelBulkUploading,
    isProductCityLevelBulkUploaded:
      state.productCityLevel.isProductCityLevelBulkUploaded,
    isProductCityLevelBulkUploadingError:
      state.productCityLevel.isProductCityLevelBulkUploadingError,
    isProductCityLevelInventoryUploading:
      state.productCityLevel.isProductCityLevelInventoryUploading,
    isProductCityLevelInventoryUploaded:
      state.productCityLevel.isProductCityLevelInventoryUploaded,
    isProductCityLevelInventoryUploadingError:
      state.productCityLevel.isProductCityLevelInventoryUploadingError,
    isNewCityLevelProductPricesUploading:
      state.productCityLevel.isNewCityLevelProductPricesUploading,
    isNewCityLevelProductPricesUploadingError:
      state.productCityLevel.isNewCityLevelProductPricesUploadingError,
    isNewCityLevelProductPricesUploaded:
      state.productCityLevel.isNewCityLevelProductPricesUploaded,
    productCityLevelDetails: state.productCityLevel.productCityLevelDetails,
    isProductCityLevelDetailsFetched:
      state.productCityLevel.isProductCityLevelDetailsFetched,
    productCityLevelBrands: state.productCityLevel.productCityLevelBrands,
    wareHouseNames: state.productCityLevel.wareHouseNames,
    productCityLevelInventory: state.productCityLevel.productCityLevelInventory,
    isProductCityLevelInventoryFetched:
      state.productCityLevel.isProductCityLevelInventoryFetched,
    isProductCityLevelInventoryUpdated:
      state.productCityLevel.isProductCityLevelInventoryUpdated,
    odooTax: state.productCityLevel.odooTax,
    isOdooTaxFetched: state.productCityLevel.isOdooTaxFetched,
    citiesList: state.zone.citiesList,
    isCityListFetched: state.zone.isCityListFetched,
    roles: state.userAuth.roles,
  };
};

export const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    fetchProductCityLevels: (cityId: string, queryPrams?: IGetQueryParams) =>
      dispatch(actions.getProductCityLevels(cityId, queryPrams)),
    bulkUploadProductCityLevel: (payload: FormData, url: string) =>
      dispatch(actions.bulkUploadProductCityLevel(payload, url)),
    inventoryUploadProductCityLevel: (payload: FormData, url: string) =>
      dispatch(actions.inventoryUploadProductCityLevel(payload, url)),
    bulkUploadNewCityLevelProductPrice: (payload: FormData, url: string) =>
      dispatch(actions.newProductCityLevelPriceUpload(payload, url)),
    clearProductCityLevelDetails: () =>
      dispatch(actions.clearProductCityLevelDetailsAction()),
    getCommandoCategories: (
      isProductCityLevelDetailPage: boolean,
      queryPrams?: IGetQueryParams
    ) =>
      dispatch(
        actions.getCategoriesList(isProductCityLevelDetailPage, queryPrams)
      ),
    fetchProductCityLevelBrands: () =>
      dispatch(actions.fetchProductCityLevelBrands()),
    productCityLevelFetchWareHouseNames: (queryParam: any) =>
      dispatch(actions.productCityLevelFetchWareHouseNames(queryParam)),
    fetchProductCityLevelInventory: (id: string, queryParam: any) =>
      dispatch(actions.fetchProductCityLevelInventory(id, queryParam)),
    updateProductCityLevelInventory: (id: string, payload: any) =>
      dispatch(actions.updateProductCityLevelInventory(id, payload)),
    productCityLevelFetchTaxFromOdoo: (id: string = "") =>
      dispatch(actions.productCityLevelFetchTaxFromOdoo(id)),
    fetchCities: () => dispatch(actions.fetchCities()),
  };
};

const ProductCityLevelContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductCityLevelPage);
export default ProductCityLevelContainer;
